import { defineSlotRecipe } from '@chakra-ui/react';

export const settingCardSlotRecipe = defineSlotRecipe({
	slots: [ 'body', 'root', 'footer' ],

	base: {
		body: { p: '32px' },

		footer: {
			bg:           '#F8F8F8',
			display:      'flex',
			placeContent: 'center',
			py:           '16px',
		},
	},
});
